export const appConstants = {
    title: 'Todo List',
    version: '2023.06.09',
    company: 'Mindbox',

    appearance: {
        baseGrey: 'rgb(245 245 245)',
        basePink: 'rgb(233 217 216)',
        darkGrey: 'rgb(189, 189, 189)',
        smallIconSize: 18,
        normalIconSize: 20,
        bigIconSize: 28,
    },
}